/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

export default function DisplaySuccessMessages(props) {
  let success_msg_read = 'frr-success-msg-read' + uuidv4();
  return (
    <div>
      {props.successMessages.length > 0 ? (
        <div
          className="alert alert-success custom-alert"
          role="alert"
          aria-describedby={success_msg_read}
        >
          <div id={success_msg_read}>
            {props.successMessages.map((message, index) => (
              <li key={index}>{message}</li>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}

DisplaySuccessMessages.propTypes = {
  successMessages: PropTypes.array.isRequired,
};
